/* tslint:disable */
/* eslint-disable */
/**
 * Mercatus Portal
 * Mercatus Portal
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@gomercatus.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
/**
 * ImpersonationApi - axios parameter creator
 * @export
 */
export const ImpersonationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Start impersonating the specified user. Requires UserImpersonation.MANAGE authority.
         * @summary Impersonate a user
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        impersonateUser: async (userId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('impersonateUser', 'userId', userId)
            const localVarPath = `/user/impersonate/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ImpersonationApi - functional programming interface
 * @export
 */
export const ImpersonationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ImpersonationApiAxiosParamCreator(configuration)
    return {
        /**
         * Start impersonating the specified user. Requires UserImpersonation.MANAGE authority.
         * @summary Impersonate a user
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async impersonateUser(userId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.impersonateUser(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ImpersonationApi - factory interface
 * @export
 */
export const ImpersonationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ImpersonationApiFp(configuration)
    return {
        /**
         * Start impersonating the specified user. Requires UserImpersonation.MANAGE authority.
         * @summary Impersonate a user
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        impersonateUser(userId: number, options?: any): AxiosPromise<void> {
            return localVarFp.impersonateUser(userId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ImpersonationApi - object-oriented interface
 * @export
 * @class ImpersonationApi
 * @extends {BaseAPI}
 */
export class ImpersonationApi extends BaseAPI {
    /**
     * Start impersonating the specified user. Requires UserImpersonation.MANAGE authority.
     * @summary Impersonate a user
     * @param {number} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImpersonationApi
     */
    public impersonateUser(userId: number, options?: any) {
        return ImpersonationApiFp(this.configuration).impersonateUser(userId, options).then((request) => request(this.axios, this.basePath));
    }
}
